import { useState } from "react";
import { camelizeKeys, snakifyKeys } from "../../../../util/helpers";
import { api, extractErrorMessage } from "../../../../util/api";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { Form } from "react-final-form";
import { SuperDialScriptForm } from "./SuperDialScriptForm";

export const EditSuperDialScriptModal = ({ superDialScript, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleUpdate = async (params) => {
    try {
      const res = await api.patch(`/admin/super_dial_scripts/${params.id}`, snakifyKeys(params));

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit SuperDial Script</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={camelizeKeys({ ...superDialScript })}>
            {(props) => <SuperDialScriptForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
